import { createContext, useContext, useState, useMemo } from "react";

const LogContext = createContext();

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${parseInt(day, 10)}-${months[parseInt(month, 10) - 1]}-${year}`;
};

export const LogProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    operator: "",
    startDate: "",
    endDate: "",
    ussdCode: "",
  });

  const formattedFilters = useMemo(() => {
    const formattedStartDate = formatDate(filters.startDate);
    const formattedEndDate = formatDate(filters.endDate);
    const dateRange =
      formattedStartDate && formattedEndDate
        ? `${formattedStartDate} - ${formattedEndDate}`
        : "";
    return {
      formattedStartDate,
      formattedEndDate,
      dateRange,
    };
  }, [filters.startDate, filters.endDate]);

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const clearFilters = () => {
    setFilters({
      operator: "",
      startDate: "",
      endDate: "",
      ussdCode: "",
    });
  };

  return (
    <LogContext.Provider
      value={{
        filters,
        formattedFilters,
        updateFilters,
        clearFilters,
      }}
    >
      {children}
    </LogContext.Provider>
  );
};

export const useLogContext = () => {
  const context = useContext(LogContext);
  if (!context) {
    throw new Error("useLogContext must be used within a FilterProvider");
  }
  return context;
};
